import { render, staticRenderFns } from "./details.vue?vue&type=template&id=0ae5c854&"
import script from "./details.vue?vue&type=script&lang=js&"
export * from "./details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.10.1_cache-loader@4.1.0_webpack@4.46.0_supports-color@7.2.0___css-loader@_7cda17688b6d9c5afadeb45a1beb9a27/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports